import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { loadData } from "../../../store/actions/dashactions";
import axios from "axios";
import { API_BASE_URL } from "../../../config";

import moment from 'moment';




function Home(props) {




  useEffect(() => {
    handleSubmit();
  }, [])

  const [sumdata, setSumdata] = useState([]);

  const [selFY, setSelectedFY] = useState('')
  const [selLy, setselLy] = useState('In-Lease')
  const currentYear = moment().month() >= 6 ? moment().year() + 1 : moment().year();
  const startYear = 2024;

  const options = Array.from({ length: currentYear - startYear + 6 }, (_, i) => {
    const year = startYear + i;
    return {
      value: year,
      label: `FY ${year.toString().slice(-2)}`
    };
  });

  const handleSubmit = (event) => {
    if (event) event.preventDefault(); // only call preventDefault if triggered by form
    const leasetype = event?.target?.leasetype?.value || "In-Lease";
    setselLy(leasetype)
    const fyyear = parseInt(event?.target?.fyyear?.value || currentYear); // e.g. 2024 for FY 2024 (July 2024 – June 2025)

    // FY period
    const fyStart = `${fyyear - 1}-07-01`;
    const fyEnd = `${fyyear}-06-30`;

    axios.post(`${API_BASE_URL}api/leasegeneralreport`, {
      leasetype, fyStart, fyEnd
    })
      .then((response) => {
        const allLeases = response.data;

        const result = getTotalFYBaseRent(allLeases, fyyear);


        setSumdata(result); // only leases active in that FY
        // setltype(`(${leasetype})`);
        setSelectedFY(fyyear); // optional: store current FY
        // setReport(`FY ${fyyear.toString().slice(-2)}`)
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getTotalFYBaseRent = (leases, targetFY) => {
    let totalAnnualRentBase = 0;
    let totalMonthlyBaseRent = 0;
    // Step 2: Get unique leasecode count
    const uniqueLeaseCodes = new Set(leases.map(l => l.leasecode));
    const totalLeaseCount = uniqueLeaseCodes.size;
    let activeLeaseCount = 0;
    let totalSqftOccupied = 0;
    let subleaseSqftOccupied = 0;
    let totalbuildingSqftOccupied = 0;
    let subleaseCount = 0;
    let newLeaseCount = 0;
    let terminatedLeaseCount = 0;
    let expiringWithin6Months = 0;

    const fyStart = moment(`${targetFY - 1}-07-01`);
    const fyEnd = moment(`${targetFY}-06-30`);
    const today = moment();
    const sixMonthsFromToday = today.clone().add(6, 'months');

    const countedLeaseCodes = new Set(); //  Track counted leases
    // ✅ Initialize agreement summaries
    const agreementSummary = {
      "UseOccupancy": { total: 0, expiringWithin6Months: 0, terminated: 0 },
      "Sublease": { total: 0, expiringWithin6Months: 0, terminated: 0 },
      "License": { total: 0, expiringWithin6Months: 0, terminated: 0 },
      "Lease": { total: 0, expiringWithin6Months: 0, terminated: 0 },
      "Easement": { total: 0, expiringWithin6Months: 0, terminated: 0 },
      "Other": { total: 0, expiringWithin6Months: 0, terminated: 0 }

    };
    // ✅ Property tracking
    const uniquePropertyIds = new Set();
    let acquiredCount = 0;
    let disposedCount = 0;

    // ✅ Build tracking
    const uniqueBuildingIds = new Set();
    let acquiredCount1 = 0;
    let disposedCount1 = 0;

    leases.forEach((lease) => {
      const leaseStart = moment(lease.commence_date);
      const leaseEnd = moment(lease.expiration_date);
      const terminatedDate = lease.leasterminateddate ? moment(lease.leasterminateddate) : null;

      const isActiveInFY = leaseStart.isSameOrBefore(fyEnd) && leaseEnd.isSameOrAfter(fyStart);
      const isNewLeaseInFY = leaseStart.isBetween(fyStart, fyEnd, null, '[]');
      const isTerminatedInFY = lease.leaseterminatedflag === 'Y' && terminatedDate && terminatedDate.isSameOrBefore(fyEnd);
      const isExpiringSoon = leaseEnd.isSameOrBefore(sixMonthsFromToday) && leaseEnd.isAfter(today);

      if (lease.subleaseflag === 'Y') subleaseCount++;
      if (isNewLeaseInFY) newLeaseCount++;
      if (isTerminatedInFY) terminatedLeaseCount++;
      if (isExpiringSoon) expiringWithin6Months++;

      totalSqftOccupied += lease.areasf ?? 0;
      totalbuildingSqftOccupied += lease.buildingsf ?? 0;

      // ✅ Property-based logic
      if (lease.pid) uniquePropertyIds.add(lease.pid);
      if (lease.pid) {
        if (lease.prand === "1") disposedCount++;
        else acquiredCount++;
      }

      if (lease.bid) uniqueBuildingIds.add(lease.bid);
      if (lease.bid) {
        if (lease.brand === "1") disposedCount1++;
        else acquiredCount1++;
      }



      const fyValues = getFYBaseRentValues(targetFY, lease);
      const monthlyBase1 = fyValues.monthlyBase1 ?? 0;
      const monthlyBase2 = fyValues.monthlyBase2 ?? 0;
      const months1 = fyValues.months1 ?? 0;
      const months2 = fyValues.months2 ?? 0;
      const monthlyOther = lease.monthlyrentother ?? 0;
      const monthlyCam = lease.monthlyrentcam ?? 0;

      totalMonthlyBaseRent += monthlyBase1 + monthlyBase2 + monthlyOther + monthlyCam;
      totalAnnualRentBase += (monthlyBase1 * months1) + (monthlyBase2 * months2) + (monthlyOther * (months1 + months2)) + (monthlyCam * (months1 + months2));


      // --- 🧩 New Agreement Summary Counters ---
      const agreementType = (lease.agreement || '');
      console.log(agreementType)
      let key = null;
      if (agreementType.includes('Use') || agreementType.includes('Occupancy')) {
        key = "UseOccupancy";
      } else if (agreementType.includes('Sublease')) {
        key = "Sublease";
        subleaseSqftOccupied += lease.areasf ?? 0;
      } else if (agreementType.includes('License')) {
        key = "License";
      } else if (agreementType.includes('Lease')) {
        key = "Lease";
      } else if (agreementType.includes('Other')) {
        key = "Other";
      } else if (agreementType.includes('Easement')) {
        key = "Easement";
      }
      console.log(key)

      if (key) {
        agreementSummary[key].total++;

        if (lease.leaseterminatedflag === 'Y') {
          agreementSummary[key].terminated++;
        }

        if (leaseEnd.isSameOrBefore(sixMonthsFromToday) && leaseEnd.isAfter(today)) {
          agreementSummary[key].expiringWithin6Months++;
        }
      }
      if (!isActiveInFY) return;

      // activeLeaseCount++;
      // Count only unique lease codes for active leases
      if (isActiveInFY && !countedLeaseCodes.has(lease.leasecode)) {
        countedLeaseCodes.add(lease.leasecode);
        activeLeaseCount++;
      }
    });

    return {
      totalAnnualRentBase: parseFloat(totalAnnualRentBase.toFixed(2)),
      totalMonthlyBaseRent: parseFloat(totalMonthlyBaseRent.toFixed(2)),
      totalLeaseCount,
      activeLeaseCount,
      totalSqftOccupied1: (totalSqftOccupied - subleaseSqftOccupied),
      totalbuildingSqftOccupied,
      subleaseCount,
      newLeaseCount,
      terminatedLeaseCount,
      expiringWithin6Months,
      // ✅ new property info
      totalPropertyCount: uniquePropertyIds.size,
      acquiredCount,
      disposedCount,
      totalBuildingCount: uniqueBuildingIds.size,
      acquiredCount1,
      disposedCount1,
      agreementSummary // ✅ Include 3-type summary here
    };
  };

  const getFYBaseRentValues = (targetFY, infoDetail) => {
    const basePSF = infoDetail.rentpersf ?? 0;
    const sqft = infoDetail.fsqft ?? infoDetail.areasf ?? 0;
    const escalationPercent = infoDetail.escalationpercent ?? 0;

    const commence = moment(infoDetail.rental_commence_date || infoDetail.commence_date);

    // Use leasterminateddate if it exists and is earlier than expiration_date
    let expire = moment(infoDetail.expiration_date);
    if (infoDetail.leasterminateddate && moment(infoDetail.leasterminateddate).isBefore(expire)) {
      expire = moment(infoDetail.leasterminateddate);
    }

    const currentStart = commence.clone();

    const stopDates = (infoDetail.internal_stop_dates ?? []).map(date => moment(date)).sort((a, b) => a - b);

    let psf = basePSF;
    let start = currentStart.clone();

    const fyStart = moment.utc(`${targetFY - 1}-07-01`);
    const fyEnd = moment.utc(`${targetFY}-06-30`);

    const results = [];

    while (start.isSameOrBefore(expire)) {
      let end = start.clone().add(1, 'year').subtract(1, 'day');

      const stop = stopDates.find(d => d.isSameOrAfter(start) && d.isSameOrBefore(end));
      if (stop) end = stop.clone();

      if (end.isAfter(expire)) end = expire.clone();

      const overlapStart = moment.max(start, fyStart);
      const overlapEnd = moment.min(end, fyEnd);

      if (overlapStart.isSameOrBefore(overlapEnd)) {
        const months = overlapEnd.diff(overlapStart, 'months') + 1;
        const monthlyBase = parseFloat(((psf * sqft) / 12).toFixed(2));

        results.push({
          months,
          psf: parseFloat((Math.floor(psf * 100) / 100).toFixed(2)),
          monthlyBase
        });
      }

      const isFullYear = end.diff(start, 'months') >= 11;
      const wasStoppedEarly = stop && stop.isSame(end);
      if (isFullYear || wasStoppedEarly) {
        psf *= 1 + escalationPercent / 100;
      }

      start = end.clone().add(1, 'day');
      if (start.isAfter(expire)) break;
    }

    // Rename keys for output: psf1, psf2, etc.
    const final = {};
    results.forEach((item, index) => {
      const suffix = index + 1;
      final[`months${suffix}`] = item.months;
      final[`psf${suffix}`] = item.psf;
      final[`monthlyBase${suffix}`] = item.monthlyBase;
    });

    if (final.months1 && final.months2 && (final.months1 + final.months2 > 12)) {
      final.months2 = final.months2 - 1;
    }

    return final;
  };
  return (
    <>
      <div className="row mb-4 ml-1">
        <div className="col-md-8 row">
          <div className="col-md-12 text-center">
            <div className="pro-head">{selLy} Portfolio
              <span className="small-pro"> {(selLy == 'Out-Lease' ? '(County-Owned Properties)' : '(Non-County-Owned Properties)')}</span>
            </div>
          </div>
          <div className="col-md-12">
            <div className="report-card pb-2" >
              <div className="report-card2 rs-brd mr-2" >
                <div className="report-label1" style={{ color: '#1E1E1E' }}>Total Agreements</div>
                <div className="report-value box" >{(sumdata.totalLeaseCount || 0)}</div>
              </div>
              <div className="report-card2 text-expire rs-brd mr-2">
                <div className="report-label1" >Expiring within six months</div>
                <div className="report-value box" style={{ background: 'chocolate' }} >{(sumdata.expiringWithin6Months || 0)}</div>
              </div>
              <div className="report-card2 text-terminated">
                <div className="report-label1" >Terminated Agreements</div>
                <div className="report-value box" style={{ background: '#C42929' }}>{(sumdata.terminatedLeaseCount || 0)}</div>
              </div>
            </div>
          </div>


          <div className="col-md-6">
            <div className="sum-cards" >
              <div className="report-card1" >
                <div className="report-label" >Total Leases</div>
                <div className="report-value box" >{(sumdata?.agreementSummary?.["Lease"]?.total || 0)}</div>
              </div>
              <div className="subreport text-expire">
                <div className="subreport-label" >Expiring within six months</div>
                <div className="subreport-value" >{(sumdata?.agreementSummary?.["Lease"]?.expiringWithin6Months || 0)}</div>
              </div>
              <div className="subreport text-terminated">
                <div className="subreport-label" >Terminated</div>
                <div className="subreport-value" >{(sumdata?.agreementSummary?.["Lease"]?.terminated || 0)}</div>
              </div>
            </div>
          </div>

          {(selLy == 'Out-Lease' ?
            <div className="col-md-6">
              <div className="sum-cards" >
                <div className="report-card1" >
                  <div className="report-label" >Total Use & <br />Occupancy Agreements</div>
                  <div className="report-value box" >{(sumdata?.agreementSummary?.["UseOccupancy"]?.total || 0)}</div>
                </div>
                <div className="subreport text-expire">
                  <div className="subreport-label" >Expiring within six months</div>
                  <div className="subreport-value" >{(sumdata?.agreementSummary?.["UseOccupancy"]?.expiringWithin6Months || 0)}</div>
                </div>
                <div className="subreport text-terminated">
                  <div className="subreport-label" >Terminated</div>
                  <div className="subreport-value" >{(sumdata?.agreementSummary?.["UseOccupancy"]?.terminated || 0)}</div>
                </div>
              </div>
            </div> : '')}



          <div className="col-md-6">
            <div className="sum-cards" >
              <div className="report-card1" >
                <div className="report-label" >Total Subleases</div>
                <div className="report-value box" >{(sumdata?.agreementSummary?.["Sublease"]?.total || 0)}</div>
              </div>
              <div className="subreport text-expire">
                <div className="subreport-label" >Expiring within six months</div>
                <div className="subreport-value" >{(sumdata?.agreementSummary?.["Sublease"]?.expiringWithin6Months || 0)}</div>
              </div>
              <div className="subreport text-terminated">
                <div className="subreport-label" >Terminated</div>
                <div className="subreport-value" >{(sumdata?.agreementSummary?.["Sublease"]?.terminated || 0)}</div>
              </div>
            </div>
          </div>


          <div className="col-md-6">
            <div className="sum-cards" >
              <div className="report-card1" >
                <div className="report-label" >Total Licenses</div>
                <div className="report-value box" >{(sumdata?.agreementSummary?.["License"]?.total || 0)}</div>
              </div>
              <div className="subreport text-expire">
                <div className="subreport-label" >Expiring within six months</div>
                <div className="subreport-value" >{(sumdata?.agreementSummary?.["License"]?.expiringWithin6Months || 0)}</div>
              </div>
              <div className="subreport text-terminated">
                <div className="subreport-label" >Terminated</div>
                <div className="subreport-value" >{(sumdata?.agreementSummary?.["License"]?.terminated || 0)}</div>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="sum-cards" >
              <div className="report-card1" >
                <div className="report-label" >Total Other Agreements</div>
                <div className="report-value box" >{(sumdata?.agreementSummary?.["Other"]?.total || 0)}</div>
              </div>
              <div className="subreport text-expire">
                <div className="subreport-label" >Expiring within six months</div>
                <div className="subreport-value" >{(sumdata?.agreementSummary?.["Other"]?.expiringWithin6Months || 0)}</div>
              </div>
              <div className="subreport text-terminated">
                <div className="subreport-label" >Terminated</div>
                <div className="subreport-value" >{(sumdata?.agreementSummary?.["Other"]?.terminated || 0)}</div>
              </div>
            </div>
          </div>

          {(selLy == 'Out-Lease' ?
            <div className="col-md-6">
              <div className="sum-cards" >
                <div className="report-card1" >
                  <div className="report-label" >Total Easements</div>
                  <div className="report-value box" >{(sumdata?.agreementSummary?.["Easement"]?.total || 0)}</div>
                </div>
                <div className="subreport text-expire">
                  <div className="subreport-label" >Expiring within six months</div>
                  <div className="subreport-value" >{(sumdata?.agreementSummary?.["Easement"]?.expiringWithin6Months || 0)}</div>
                </div>
                <div className="subreport text-terminated">
                  <div className="subreport-label" >Terminated</div>
                  <div className="subreport-value" >{(sumdata?.agreementSummary?.["Easement"]?.terminated || 0)}</div>
                </div>
              </div>
            </div> : '')}

          <div className="col-md-12 text-center">
            <div className="agg-head"> Aggregate  {selLy} Metrics :</div>
          </div>
          {(selLy == 'Out-Lease' ?
            <div className="col-md-12">

              {/* <div className="report-card" >
            <div className="report-label" >Total Active Leases</div>
            <div className="report-value box" >{(sumdata.activeLeaseCount-sumdata.terminatedLeaseCount ||0)}</div>
          </div> */}
              <div className="report-card">
                <div className="report-label"><b>IG</b> (Total FY Income-Generating Agreements)</div>
                <div className="report-value">${(sumdata.totalAnnualRentBase || 0).toLocaleString()}</div>
              </div>
              <div className="report-card">
                <div className="report-label"><b>NIG </b> (Total FY Non-income-Generating Agreements)</div>
                <div className="report-value">${(0).toLocaleString()}</div>
              </div>
              {/* <div className="report-card">
            <div className="report-label">Monthly Lease Cost</div>
            <div className="report-value">${(sumdata.totalMonthlyBaseRent ||0).toLocaleString()}</div>
          </div> */}
              <div className="report-card">
                <div className="report-label">Total Building Square Footage (County-Owned)</div>
                <div className="report-value">{(sumdata.totalbuildingSqftOccupied || 0).toLocaleString()}</div>
              </div>
              <div className="report-card">
                <div className="report-label">Total Sq. Ft. - County Occupied</div>
                <div className="report-value">{(sumdata.totalSqftOccupied1 || 0).toLocaleString()}</div>
              </div>
              <div className="report-card">
                <div className="report-label">Total Sq. Ft. - Non-County Occupied</div>
                <div className="report-value">{(0).toLocaleString()}</div>
              </div>
            </div> :


            <div className="col-md-12">
              <div className="report-card">
                <div className="report-label">Total Rent Obligations (RL)</div>
                <div className="report-value">${(sumdata.totalAnnualRentBase || 0).toLocaleString()}</div>
              </div>
              <div className="report-card">
                <div className="report-label">Total Square Footage (County-Leased)</div>
                <div className="report-value">{(sumdata.totalSqftOccupied1 || 0).toLocaleString()}</div>
              </div>
            </div>)}
        </div>
        <div className="col-md-4">
          <form onSubmit={handleSubmit} className="dash-form">
            <div className="form-row" style={{ alignItems: 'flex-end' }}>
              <div className="form-group col-md-12">
                <select className="form-control" defaultValue={"In-Lease"} id="leasetype" name="leasetype">
                  <option value={"In-Lease"} >In-Lease</option>
                  <option value={"Out-Lease"} >Out-Lease</option>
                </select>
              </div>
              <div className="form-group col-md-12">

                <select className="form-control" defaultValue={currentYear} id="fyyear" name="fyyear" >
                  {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group col-md-12 mt-3">
                <button type="submit" className="btn btn-primary btn-apl">Apply</button>
              </div>
            </div>
          </form>



          {/*
        <div className="col-md-12 mt-5">
          <div className="sum-cards" >
            <div className="report-card1" >
              <div className="report-label" >Total Property ID/TAX ID</div>
              <div className="report-value box" >{(sumdata.totalPropertyCount ||0)}</div>
            </div>
            <div className="subreport text-primary">
              <div className="subreport-label" >Acquired</div>              
              <div className="subreport-value" >{(sumdata.totalPropertyCount ||0)}</div>
            </div>
            <div className="subreport text-terminated">
              <div className="subreport-label" >Disposed</div>               
              <div className="subreport-value" >{(0)}</div>
            </div>
          </div>
        </div>
        
        <div className="col-md-12">
          <div className="sum-cards" >
            <div className="report-card1" >
              <div className="report-label" >Total Building ID/L # </div>
              <div className="report-value box" >{(sumdata.totalBuildingCount ||0)}</div>
            </div>
            <div className="subreport text-primary">
              <div className="subreport-label" >Acquired</div>              
              <div className="subreport-value" >{(sumdata.totalBuildingCount ||0)}</div>
            </div>
            <div className="subreport text-terminated">
              <div className="subreport-label" >Disposed</div>              
              <div className="subreport-value" >{(0)}</div>
            </div>
          </div>
        </div>
        */}


        </div>

      </div>


    </>
  );
}

const mapStateToProps = (state) => {
  return {
    lease: state.HomeReducer.lease,
    surplus: state.HomeReducer.surplus
  }
};

const mapDispatchToProps = {
  loadData: (leasetype) => loadData(leasetype)
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
